var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 34,
    viewBox: "0 0 29 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2991 17.9259C6.50782 17.9259 0.258545 24.2 0.258545 32.0222C0.258545 32.5926 0.745501 33.0815 1.31362 33.0815C1.88173 33.0815 2.36869 32.5926 2.36869 32.0222C2.36869 25.4222 7.72521 19.9629 14.3803 19.9629C20.9542 19.9629 26.3919 25.3407 26.3919 32.0222C26.3919 32.5926 26.8788 33.0815 27.447 33.0815C28.0151 33.0815 28.502 32.5926 28.502 32.0222C28.2585 24.2 22.0093 17.9259 14.2991 17.9259Z",
    fill: "#606060"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2991 16.7037C18.9252 16.7037 22.6585 12.9556 22.6585 8.31111C22.6585 3.66667 18.844 0 14.2991 0C9.67303 0 5.9397 3.74815 5.9397 8.39259C5.9397 13.037 9.67303 16.7037 14.2991 16.7037ZM14.2991 2.03704C17.789 2.03704 20.6296 4.88889 20.6296 8.39259C20.6296 11.8963 17.7078 14.6667 14.2991 14.6667C10.8904 14.6667 7.96868 11.8148 7.96868 8.31111C7.96868 4.80741 10.8093 2.03704 14.2991 2.03704Z",
    fill: "#606060"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.479befdf53ad8cb0389498165fa7b6be.svg";
export { ForwardRef as ReactComponent };